import {differenceInSeconds} from 'date-fns/differenceInSeconds'
import {parseISO} from 'date-fns/parseISO'

import {formatDuration} from '../../../../utils/dateTimeUtils'

type BuildDurationValueProps = {
  className?: string
  title?: string
  started?: string | null | undefined
  finished?: string | null | undefined
  exact?: boolean
}

export default function BuildDurationValue({
  className,
  title = 'Duration',
  started,
  finished,
  exact = false,
}: BuildDurationValueProps) {
  if (started == null || finished == null) {
    return null
  }

  const duration = formatDuration(differenceInSeconds(parseISO(finished), parseISO(started)), {
    alwaysShowSeconds: exact,
  })

  return (
    <span className={className} title={title}>
      {duration}
    </span>
  )
}
